// third-party
import { configureStore } from '@reduxjs/toolkit';

// project import
import reducers from './reducers';

// const reducer : 

const store = configureStore({
    reducer: reducers,
});

const { dispatch } = store;

export { store, dispatch };



export const openDrawer = (payload) => ({
    type: "UPDATE_MENU_ACTION",
    payload
})